import { Link } from 'react-router-dom';
import { Home, Search, ArrowLeft, Newspaper } from 'lucide-react';
import styles from './NotFoundPage.module.css';

export default function NotFoundPage() {
  return (
    <main className={styles.notFound}>
      <div className="container">
        <div className={styles.content}>
          <div className={styles.icon}>
            <Newspaper size={64} />
          </div>
          
          <h1 className={styles.errorCode}>404</h1>
          <h2 className={styles.title}>Página no encontrada</h2>
          
          <p className={styles.description}>
            Lo sentimos, la página que buscas no existe o ha sido movida.
            Puede que el enlace esté roto o la dirección haya cambiado.
          </p>

          <div className={styles.actions}>
            <Link to="/" className="btn btn-primary">
              <Home size={18} />
              Ir al inicio
            </Link>
            <Link to="/buscar" className="btn btn-outline">
              <Search size={18} />
              Buscar noticias
            </Link>
          </div>

          <button 
            onClick={() => window.history.back()} 
            className={styles.backLink}
          >
            <ArrowLeft size={16} />
            Volver a la página anterior
          </button>
        </div>

        <div className={styles.suggestions}>
          <h3>Quizás te interese:</h3>
          <ul>
            <li><Link to="/">Últimas noticias</Link></li>
            <li><Link to="/seccion/politica">Política</Link></li>
            <li><Link to="/seccion/deportes">Deportes</Link></li>
            <li><Link to="/ediciones">Ediciones impresas</Link></li>
          </ul>
        </div>
      </div>
    </main>
  );
}
